module.exports = __webpack_public_path__ + "static/img/02.b089f695.png";